import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./TermsandConditions.css";
import { useEffect } from "react";
import { FaChevronUp } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
const Terms_and_Conditions = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const fben = {
    "1": "Terms and Conditions",
    "2": "Home"
  }

  const fbka = {
    "1": "ನಿಯಮಗಳು ಮತ್ತು ಶರತ್ತುಗಳು",
    "2": "ಮರಳಿ ಪ್ರಥಮ ಪುಟಕ್ಕೆ"
  }

  const fbte = {
    "1": "నిబంధనలు మరియు షరతులు",
    "2": "హోం"
  }
  const fbhi = {
    "1": "नियम और शर्तें",
    "2": "होम"

  }
  const fbta ={
    "1": "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
    "2": "முகப்புப் பக்கம்"
  }
  const sectionsta = [
    { title: "விதிமுறைகளை ஏற்றுக்கொள்வது ", content: [
      "எங்கள் வலைத்தளத்தை அணுகுவதன் மூலம் அல்லது பயன்படுத்துவதன் மூலம், இந்த விதிமுறைகள் மற்றும் நிபந்தனைகள், அத்துடன் எங்கள் தனியுரிமைக் கொள்கை மற்றும் பிற பொருந்தக்கூடிய கொள்கைகளுக்கு இணங்க ஒப்புக்கொள்கிறீர்கள். இந்த விதிமுறைகளை நீங்கள் ஏற்கவில்லை என்றால், தயவுசெய்து எங்கள் வலைத்தளத்தைப் பயன்படுத்த வேண்டாம்."
    ] },
    { title: "பயனர் பதிவு ", content: [
      "எங்கள் வலைத்தளத்தில் கொள்முதல் செய்ய அல்லது சில அம்சங்களை அணுக நீங்கள் ஒரு கணக்கை உருவாக்க வேண்டியிருக்கலாம். பதிவு செய்யும் போது துல்லியமான, தற்போதைய மற்றும் முழுமையான தகவல்களை வழங்கவும், இந்தத் தகவலின் துல்லியத்தைப் பராமரிக்கவும் நீங்கள் ஒப்புக்கொள்கிறீர்கள். உங்கள் பயனர்பெயர் மற்றும் கடவுச்சொல் உட்பட உங்கள் கணக்குத் தகவலின் ரகசியத்தன்மையைப் பராமரிப்பதற்கு நீங்கள் பொறுப்பு. உங்கள் கணக்கின் எந்தவொரு அங்கீகரிக்கப்படாத பயன்பாட்டையும் உடனடியாக எங்களுக்குத் தெரிவிக்க ஒப்புக்கொள்கிறீர்கள்."
    ] },
    { title: "தயாரிப்பு தகவல் மற்றும் கிடைக்கும் தன்மை ", content: [
      "எங்கள் வலைத்தளத்தில் துல்லியமான தயாரிப்பு விளக்கங்கள், படங்கள் மற்றும் விலைகளை வழங்க நாங்கள் பாடுபடுகிறோம். இருப்பினும், பிழைகள் அல்லது முரண்பாடுகள் இருக்கலாம். இதுபோன்ற பிழைகளை சரிசெய்து, தவறான தகவல்களின் அடிப்படையில் எந்த ஆர்டர்களையும் ரத்து செய்யும் உரிமையை நாங்கள் கொண்டுள்ளோம். தயாரிப்பு கிடைக்கும் தன்மை மாற்றத்திற்கு உட்பட்டது, மேலும் அனைத்து பொருட்களும் எப்போதும் இருப்பில் இருக்கும் என்று நாங்கள் உத்தரவாதம் அளிக்க முடியாது."
    ] },
    { title: "விலை நிர்ணயம் மற்றும் கட்டணம் ", content: [
      "அனைத்து விலைகளும் இந்திய ரூபாயில் பட்டியலிடப்பட்டுள்ளன, வேறுவிதமாகக் கூறப்படாவிட்டால் பொருந்தக்கூடிய வரிகளும் அடங்கும். முன்னறிவிப்பு இல்லாமல் எந்த நேரத்திலும் விலைகளை மாற்ற எங்களுக்கு உரிமை உண்டு. தயாரிப்புகளுக்கான கட்டணம் செக் அவுட்டில் கிடைக்கக்கூடிய கட்டண முறைகள் (கிரெடிட்/டெபிட் கார்டு, நெட் பேங்கிங், UPI போன்றவை) மூலம் செய்யப்பட வேண்டும். உங்கள் கட்டணத் தகவல் மூன்றாம் தரப்பு கட்டண நுழைவாயில்கள் மூலம் பாதுகாப்பாக செயலாக்கப்படும்."
    ] },
    { title: "ஆர்டர் ஏற்பு மற்றும் அனுப்புதல் ", content: [
      "ஆர்டர் செய்த பிறகு, உங்களுக்கு மின்னஞ்சல் உறுதிப்படுத்தல் அனுப்பப்படும். இந்த மின்னஞ்சல் நாங்கள் ஆர்டரை ஏற்றுக்கொண்டதைக் குறிக்கவில்லை. எங்கள் விருப்பப்படி எந்த ஆர்டரையும் மறுக்கவோ அல்லது ரத்து செய்யவோ எங்களுக்கு உரிமை உண்டு. ஷிப்பிங் மற்றும் டெலிவரி காலக்கெடு தோராயமானது, மேலும் வெளிப்புற காரணிகளால் ஏற்படும் தாமதங்களுக்கு நாங்கள் பொறுப்பல்ல."
    ] },
    { title: "விதிமுறைகள் மற்றும் நிபந்தனைகளில் மாற்றங்கள்", content: [
      "இந்த விதிமுறைகள் மற்றும் நிபந்தனைகளை எந்த நேரத்திலும் மாற்றவோ அல்லது புதுப்பிக்கவோ எங்களுக்கு உரிமை உண்டு. ஏதேனும் மாற்றங்கள் இந்தப் பக்கத்தில் வெளியிடப்படும், மேலும் திருத்தப்பட்ட தேதி அதற்கேற்ப புதுப்பிக்கப்படும்."
    ] },
    { title: "திருப்பி அனுப்புதல், பரிமாற்றங்கள் மற்றும் பணத்தைத் திரும்பப் பெறுதல் ", content: [
      "எங்கள் திரும்பப்பெறுதல் மற்றும் பணத்தைத் திரும்பப்பெறுதல் கொள்கை, நீங்கள் தயாரிப்புகளைத் திருப்பித் தரலாம், பரிமாற்றங்களைக் கோரலாம் அல்லது பணத்தைத் திரும்பப் பெறலாம் என்பதற்கான விதிமுறைகளைக் கோடிட்டுக் காட்டுகிறது. அசல் நிலையில் உள்ள தயாரிப்புகளுக்கு மட்டுமே (திறக்கப்படாத, பயன்படுத்தப்படாத, பேக்கேஜிங் அப்படியே) பணத்தைத் திரும்பப் பெறுதல் அல்லது பரிமாற்றங்கள் ஏற்றுக்கொள்ளப்படும். பணத்தைத் திரும்பப்பெறுதல் அசல் கட்டண முறைக்கு செயலாக்கப்படும், மேலும் அதைப் பிரதிபலிக்க [X வணிக நாட்கள்] ஆகலாம்."
    ] },
    { title: "ஆளும் சட்டம்", content: [
      "இந்த விதிமுறைகள் மற்றும் நிபந்தனைகள் இந்திய சட்டங்களால் நிர்வகிக்கப்பட்டு, அவற்றின்படி பொருள் கொள்ளப்படும். இந்த விதிமுறைகளிலிருந்து எழும் எந்தவொரு சர்ச்சையும் இந்தியாவின் கர்நாடகாவின் பெங்களூரில் அமைந்துள்ள நீதிமன்றங்களின் பிரத்யேக அதிகார வரம்பிற்கு உட்பட்டது."
    ] },
    { title: "பயனர் பொறுப்புகள்", content: [
      "பொருந்தக்கூடிய™ அனைத்து உள்ளூர், மாநில மற்றும் தேசிய சட்டங்களின்படி வலைத்தளத்தைப் பயன்படுத்த நீங்கள் ஒப்புக்கொள்கிறீர்கள். எந்தவொரு சட்டவிரோத அல்லது மோசடி நடவடிக்கைகளுக்கும் வலைத்தளத்தைப் பயன்படுத்த மாட்டீர்கள். உங்கள் கணக்கின் பாதுகாப்பைப் பராமரிப்பதற்கு நீங்கள் பொறுப்பு."
    ] },
    { title: "அறிவுசார் சொத்து ", content: [
      "வலைத்தளத்தில் உள்ள அனைத்து உள்ளடக்கங்களும், உரை, படங்கள், கிராபிக்ஸ் மற்றும் லோகோக்கள் உட்பட, டெர்ரா கிளென்ஸுக்குச் சொந்தமானவை அல்லது உரிமம் பெற்றவை மற்றும் அறிவுசார் சொத்துரிமைச் சட்டங்களால் பாதுகாக்கப்படுகின்றன. முன் எழுத்துப்பூர்வ ஒப்புதல் இல்லாமல் வலைத்தளத்திலிருந்து எந்த உள்ளடக்கத்தையும் நீங்கள் நகலெடுக்கவோ, மீண்டும் உருவாக்கவோ அல்லது பயன்படுத்தவோ கூடாது."
    ] },
    { title: "பொறுப்பின் வரம்பு", content: [
      "வலைத்தளத்தைப் பயன்படுத்துவதிலிருந்தோ அல்லது பயன்படுத்த இயலாமையிலிருந்தோ ஏற்படும் எந்தவொரு நேரடி, மறைமுக, தற்செயலான, சிறப்பு அல்லது விளைவான சேதங்களுக்கும் டெர்ரா கிளென்ஸ் பொறுப்பேற்காது. எந்தவொரு சந்தர்ப்பத்திலும் எங்கள் பொறுப்பு நீங்கள் வாங்கிய தயாரிப்பு(களுக்கு) செலுத்திய தொகையை விட அதிகமாக இருக்காது."
    ] },
    { title: "எங்களை தொடர்பு கொள்ள ", content: [
      "விசாரணைகளுக்கு, எங்களை தொடர்பு கொள்ளவும்:",
      "மின்னஞ்சல்:  Support@terraclenz.com",
      "தொலைபேசி: 7022519222"
    ] }
  ];
  const sectionsen = [
    {
      title: "Acceptance of Terms", content: [
        "By accessing or using our website, you agree to comply with these Terms and Conditions, as well as our Privacy Policy and other applicable policies.",
        "If you do not agree to these terms, please do not use our website."
      ]
    },
    {
      title: "User Registration", content: [
        "You may be required to create an account to make purchases or access certain features on our website.",
        "You agree to provide accurate, current, and complete information when registering and maintain the accuracy of this information.",
        "You are responsible for maintaining the confidentiality of your account information, including your username and password.",
        "You agree to notify us immediately of any unauthorized use of your account."
      ]
    },
    {
      title: "Product Information and Availability", content: [
        "We strive to provide accurate product descriptions, images, and prices on our website.",
        "However, there may be errors or discrepancies. We reserve the right to correct any such errors and cancel any orders based on inaccurate information.",
        "Product availability is subject to change, and we cannot guarantee that all items will always be in stock."
      ]
    },
    {
      title: "Pricing and Payment", content: [
        "All prices are listed in Indian Rupees and include applicable taxes unless stated otherwise.",
        "We reserve the right to change prices at any time without prior notice.",
        "Payment for products must be made via the available payment methods (credit/debit card, net banking, UPI, etc.) at checkout.",
        "Your payment information is processed securely through third-party payment gateways."
      ]
    },
    {
      title: "Order Acceptance and Shipping", content: [
        "After placing an order, you will receive an email confirmation. This email does not signify our acceptance of the order.",
        "We reserve the right to refuse or cancel any order at our discretion.",
        "Shipping and delivery timelines are estimates, and we are not responsible for delays caused by external factors."
      ]
    },
    {
      title: "Returns, Exchanges, and Refunds", content: [
        "Our Return and Refund Policy outlines the terms under which you can return products, request exchanges, or receive a refund.",
        "Returns or exchanges are only accepted for products in their original condition (unopened, unused, with packaging intact).",
        "Refunds will be processed to the original payment method and may take [X business days] to reflect."
      ]
    },
    {
      title: "User Responsibilities", content: [
        "You agree to use the Website in accordance with all applicable local, state, and national laws.",
        "You will not use the Website for any unlawful or fraudulent activities.",
        "You are responsible for maintaining the security of your account."
      ]
    },
    {
      title: "Intellectual Property", content: [
        "All content on the Website, including text, images, graphics, and logos, is owned by or licensed to Terraclenz™ and is protected by intellectual property laws.",
        "You may not copy, reproduce, or use any content from the Website without prior written consent."
      ]
    },
    {
      title: "Limitation of Liability", content: [
        "Terraclenz™ will not be held liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use the Website.",
        "In no event shall our liability exceed the amount paid by you for the product(s) purchased."
      ]
    },
    {
      title: "Modifications to Terms and Conditions", content: [
        "We reserve the right to modify or update these Terms and Conditions at any time.",
        "Any changes will be posted on this page, and the revised date will be updated accordingly."
      ]
    },
    {
      title: "Governing Law", content: [
        "These Terms and Conditions shall be governed by and construed in accordance with the laws of India.",
        "Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts located in Bangalore, Karnataka, India."
      ]
    },
    {
      title: "Contact Us", content: [
        "For inquiries, contact us at: ",
        "Email: Support@terraclenz.com  ",
        "Phone: 7022519222"
      ]
    }
  ];
  const sectionste = [
    {
      "title": "నిబంధనలు అంగీకారం", "content": [
        "మా వెబ్‌సైట్‌ను యాక్సెస్ చేయడం లేదా ఉపయోగించడం ద్వారా, మీరు ఈ నిబంధనలు మరియు షరతులు, అలాగే మా గోప్యతా విధానం మరియు ఇతర వర్తించే విధులను అనుసరించడానికి అంగీకరిస్తున్నారు.",
        "ఈ నిబంధనలను అంగీకరించని పక్షంలో, దయచేసి మా వెబ్‌సైట్‌ను ఉపయోగించవద్దు."
      ]
    },
    {
      "title": "వినియోగదారుడు నమోదు", "content": [
        "మా వెబ్‌సైట్‌లో కొన్నీ ఫీచర్లు యాక్సెస్ చేయడానికి లేదా కొనుగోలు చేయడానికి ఖాతా సృష్టించడం అవసరమవుతుండవచ్చు.",
        "మీరు నమోదు సమయంలో ఖచ్చితమైన, ప్రస్తుత, మరియు పూర్తి సమాచారాన్ని అందించడానికి, అలాగే ఈ సమాచారాన్ని నవీకరించడానికి అంగీకరిస్తారు.",
        "మీ ఖాతా వివరాలు, వాడుకరి పేరు మరియు పాస్‌వర్డ్ రహస్యంగా ఉంచే బాధ్యత మీది.",
        "మీ ఖాతా అనధికారితంగా ఉపయోగించబడినట్లయితే, వెంటనే మాకు తెలియజేయాలి."
      ]
    },
    {
      "title": "ఉత్పత్తి సమాచారం మరియు అందుబాటులో ఉండడం", "content": [
        "మేము మా వెబ్‌సైట్‌లో ఖచ్చితమైన ఉత్పత్తి వివరణలు, చిత్రాలు మరియు ధరలను అందించడానికి ప్రయత్నిస్తాము.",
        "అయితే, తప్పులు లేదా వ్యత్యాసాలు ఉండవచ్చు. ఇలాంటి తప్పులను సవరించడానికి మరియు తప్పు సమాచారంపై ఆధారపడిన ఆర్డర్‌లను రద్దు చేయడానికి మాకు హక్కు ఉంది.",
        "ఉత్పత్తుల లభ్యత మారవచ్చు, మరియు అన్ని వస్తువులు ఎల్లప్పుడూ స్టాక్‌లో ఉంటాయని మేము హామీ ఇవ్వలేము."
      ]
    },
    {
      "title": "ధరలు మరియు చెల్లింపు", "content": [
        "అన్ని ధరలు భారతీయ రూపాయిలలో పేర్కొనబడి, వర్తించే పన్నులను కలిగి ఉంటాయి, లేదా వేరుగా పేర్కొనబడవచ్చు.",
        "మేము ముందస్తు నోటీసు లేకుండా ధరలను మార్పు చేసే హక్కును కలిగి ఉంటాము.",
        "ఉత్పత్తుల చెల్లింపులు చెక్అవుట్ సమయంలో అందుబాటులో ఉన్న చెల్లింపు విధానాల ద్వారా (క్రెడిట్/డెబిట్ కార్డు, నెట్ బ్యాంకింగ్, UPI మొదలైనవి) చేయాలి.",
        "మీ చెల్లింపు సమాచారం భద్రంగా మూడవ పక్ష చెల్లింపు గేట్‌వేలు ద్వారా ప్రాసెస్ చేయబడుతుంది."
      ]
    },
    {
      "title": "ఆర్డర్ అంగీకారం మరియు రవాణా", "content": [
        "మీరు ఆర్డర్ పెట్టిన తర్వాత, మీకు ఒక ఇమెయిల్ నిర్ధారణ అందుతుంది. ఈ ఇమెయిల్ మా ఆర్డర్ అంగీకారం అని భావించరాదు.",
        "మేము ఏదైనా ఆర్డర్‌ను నిరాకరించడానికి లేదా రద్దు చేయడానికి హక్కు కలిగి ఉంటాము.",
        "రవాణా మరియు డెలివరీ సమయాలు అంచనా మాత్రమే, మరియు బాహ్య కారణాల వల్ల జాప్యం జరిగితే మేము బాధ్యత వహించము."
      ]
    },
    {
      "title": "రిటర్న్‌లు, మార్పిడి మరియు రీఫండ్‌లు", "content": [
        "మా రిటర్న్ మరియు రీఫండ్ విధానం ప్రకారం మీరు ఉత్పత్తులను తిరిగి ఇవ్వడానికి, మార్పిడి కోరడానికి లేదా రీఫండ్ పొందడానికి అర్హులవుతారు.",
        "మూల ప్యాకేజింగ్‌లో ఉన్న (తెరవని, ఉపయోగించని) ఉత్పత్తులకు మాత్రమే రిటర్న్ లేదా మార్పిడి ఆమోదించబడుతుంది.",
        "రిఫండ్‌లు అసలు చెల్లింపు పద్ధతికి జమ చేయబడతాయి మరియు [X వ్యాపార రోజులు] పట్టవచ్చు."
      ]
    },
    {
      "title": "వినియోగదారుడి బాధ్యతలు", "content": [
        "మీరు వెబ్‌సైట్‌ను అన్ని వర్తించే స్థానిక, రాష్ట్ర మరియు జాతీయ చట్టాలను అనుసరించి ఉపయోగించాలి.",
        "మీరు వెబ్‌సైట్‌ను ఎలాంటి అక్రమ లేదా మోసపూరిత కార్యకలాపాలకు ఉపయోగించకూడదు.",
        "మీ ఖాతా భద్రతను కాపాడుకోవడం మీ బాధ్యత."
      ]
    },
    {
      "title": "మేధస్సు సంపత్తి", "content": [
        "వెబ్‌సైట్‌లో ఉన్న మొత్తం కంటెంట్, టెక్స్ట్, చిత్రాలు, గ్రాఫిక్స్, మరియు లోగోలు టెర్రాక్లెంజ్™ కి చెందినవి లేదా లైసెన్స్ పొందినవి మరియు మేధస్సు హక్కుల చట్టాల ద్వారా రక్షించబడి ఉంటాయి.",
        "మీరు ముందస్తు లిఖిత పూర్వక అనుమతి లేకుండా వెబ్‌సైట్‌లోని కంటెంట్‌ను కాపీ చేయడానికి, పునరుత్పత్తి చేయడానికి, లేదా ఉపయోగించడానికి వీలులేదు."
      ]
    },
    {
      "title": "బాధ్యత పరిమితి", "content": [
        "టెర్రాక్లెంజ్™ వెబ్‌సైట్‌ను ఉపయోగించడం లేదా ఉపయోగించలేకపోవడం వల్ల కలిగిన నేరుగా, పరోక్షంగా, యాదృచ్ఛికంగా, ప్రత్యేకంగా లేదా అనుబంధ నష్టాలకు బాధ్యత వహించదు.",
        "ఏ సందర్భంలోనైనా మా బాధ్యత మీకు ఉత్పత్తుల కోసం చెల్లించిన మొత్తం కంటే ఎక్కువ కాదు."
      ]
    },
    {
      "title": "నిబంధనల మార్పులు", "content": [
        "మేము ఈ నిబంధనలు మరియు షరతులను ఎప్పుడైనా మార్చడానికి లేదా నవీకరించడానికి హక్కు కలిగి ఉంటాము.",
        "ఏవైనా మార్పులు ఈ పేజీలో పోస్ట్ చేయబడతాయి మరియు సవరిస్తు తేదీ నవీకరించబడుతుంది."
      ]
    },
    {
      "title": "చట్టపరమైన పరిపాలన", "content": [
        "ఈ నిబంధనలు మరియు షరతులు భారతదేశ చట్టాల ప్రకారం పాలించబడతాయి మరియు వివరించబడతాయి.",
        "ఈ నిబంధనల నుండి ఉత్పన్నమయ్యే ఏవైనా వివాదాలకు, కర్ణాటక, బెంగళూరు కోర్టులకు ప్రత్యేక అధికార పరిధి ఉంటుంది."
      ]
    },
    {
      "title": "మమ్మల్ని సంప్రదించండి", "content": [
        "ప్రశ్నల కోసం, మమ్మల్ని సంప్రదించండి:",
        "ఇమెయిల్: Support@terraclenz.com",
        "ఫోన్: 7022519222"
      ]
    }
  ]
  const sectionska = [
    {
      title: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಸ್ವೀಕರಿಸುವಿಕೆ ", content: [
        "ನಮ್ಮ ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ಪ್ರವೇಶಿಸುವ ಮೂಲಕ ಅಥವಾ ಬಳಸುವ ಮೂಲಕ, ಈ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು, ಹಾಗೆಯೇ ನಮ್ಮ ಗೌಪ್ಯತೆ ನೀತಿ ಮತ್ತು ಇತರ ಅನ್ವಯವಾಗುವ ನೀತಿಗಳನ್ನು ಅನುಸರಿಸಲು ನೀವು ಒಪ್ಪುತ್ತೀರಿ.",
        "ಈ ನಿಯಮಗಳನ್ನು ನೀವು ಒಪ್ಪದಿದ್ದರೆ, ದಯವಿಟ್ಟು ನಮ್ಮ ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ಬಳಸಬೇಡಿ."
      ]
    },
    {
      title: "ಬಳಕೆದಾರ ನೋಂದಣಿ ", content: [
        "ನಮ್ಮ ವೆಬ್‌ಸೈಟ್‌ನಲ್ಲಿ ಖರೀದಿಗಳನ್ನು ಮಾಡಲು ಅಥವಾ ಕೆಲವು ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಪ್ರವೇಶಿಸಲು ನೀವು ಖಾತೆಯನ್ನು ರಚಿಸಬೇಕಾಗಬಹುದು.",
        "ಈ ಮಾಹಿತಿಯ ನಿಖರತೆಯನ್ನು ನೋಂದಾಯಿಸುವಾಗ ಮತ್ತು ನಿಖರವಾದ, ಪ್ರಸ್ತುತ ಮತ್ತು ಸಂಪೂರ್ಣ ಮಾಹಿತಿಯನ್ನು ಒದಗಿಸಲು ನೀವು ಒಪ್ಪುತ್ತೀರಿ.",
        "ನಿಮ್ಮ ಬಳಕೆದಾರಹೆಸರು ಮತ್ತು ಪಾಸ್‌ವರ್ಡ್ ಸೇರಿದಂತೆ ನಿಮ್ಮ ಖಾತೆಯ ಮಾಹಿತಿಯ ಗೌಪ್ಯತೆಯನ್ನು ಕಾಪಾಡಿಕೊಳ್ಳಲು ನೀವು ಜವಾಬ್ದಾರರಾಗಿರುತ್ತೀರಿ.",
        "ನಿಮ್ಮ ಖಾತೆಯ ಯಾವುದೇ ಅನಧಿಕೃತ ಬಳಕೆಯನ್ನು ತಕ್ಷಣವೇ ನಮಗೆ ತಿಳಿಸಲು ನೀವು ಒಪ್ಪುತ್ತೀರಿ."
      ]
    },
    {
      title: "ಉತ್ಪನ್ನ ಮಾಹಿತಿ ಮತ್ತು ಲಭ್ಯತೆ ", content: [
        "ನಮ್ಮ ವೆಬ್‌ಸೈಟ್‌ನಲ್ಲಿ ನಿಖರವಾದ ಉತ್ಪನ್ನ ವಿವರಣೆಗಳು, ಚಿತ್ರಗಳು ಮತ್ತು ಬೆಲೆಗಳನ್ನು ಒದಗಿಸಲು ನಾವು ಪ್ರಯತ್ನಿಸುತ್ತೇವೆ.",
        "ಆದಾಗ್ಯೂ, ದೋಷಗಳು ಅಥವಾ ವ್ಯತ್ಯಾಸಗಳು ಇರಬಹುದು. ಅಂತಹ ಯಾವುದೇ ದೋಷಗಳನ್ನು ಸರಿಪಡಿಸುವ ಹಕ್ಕನ್ನು ನಾವು ಕಾಯ್ದಿರಿಸಿದ್ದೇವೆ ಮತ್ತು ನಿಖರವಲ್ಲದ ಮಾಹಿತಿಯ ಆಧಾರದ ಮೇಲೆ ಯಾವುದೇ ಆದೇಶಗಳನ್ನು ರದ್ದುಗೊಳಿಸುತ್ತೇವೆ.",
        "ಉತ್ಪನ್ನದ ಲಭ್ಯತೆಯು ಬದಲಾವಣೆಗೆ ಒಳಪಟ್ಟಿರುತ್ತದೆ ಮತ್ತು ಎಲ್ಲಾ ಐಟಂಗಳು ಯಾವಾಗಲೂ ಸ್ಟಾಕ್‌ನಲ್ಲಿರುತ್ತವೆ ಎಂದು ನಾವು ಖಾತರಿಪಡಿಸುವುದಿಲ್ಲ."
      ]
    },
    {
      title: "ಬೆಲೆ ಮತ್ತು ಪಾವತಿ ", content: [
        "ಎಲ್ಲಾ ಬೆಲೆಗಳನ್ನು ಭಾರತೀಯ ರೂಪಾಯಿಗಳಲ್ಲಿ ಪಟ್ಟಿ ಮಾಡಲಾಗಿದೆ ಮತ್ತು ಅನ್ಯಥಾ ಹೇಳದ ಹೊರತು ಅನ್ವಯವಾಗುವ ತೆರಿಗೆಗಳನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ.",
        "ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಪೂರ್ವ ಸೂಚನೆಯಿಲ್ಲದೆ ಬೆಲೆಗಳನ್ನು ಬದಲಾಯಿಸುವ ಹಕ್ಕನ್ನು ನಾವು ಕಾಯ್ದಿರಿಸಿದ್ದೇವೆ.",
        "ಚೆಕ್‌ಔಟ್‌ನಲ್ಲಿ ಲಭ್ಯವಿರುವ ಪಾವತಿ ವಿಧಾನಗಳ ಮೂಲಕ (ಕ್ರೆಡಿಟ್/ಡೆಬಿಟ್ ಕಾರ್ಡ್, ನೆಟ್ ಬ್ಯಾಂಕಿಂಗ್, UPI, ಇತ್ಯಾದಿ) ಉತ್ಪನ್ನಗಳಿಗೆ ಪಾವತಿಯನ್ನು ಮಾಡಬೇಕು.",
        "ನಿಮ್ಮ ಪಾವತಿ ಮಾಹಿತಿಯನ್ನು ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಪಾವತಿ ಗೇಟ್‌ವೇಗಳ ಮೂಲಕ ಸುರಕ್ಷಿತವಾಗಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ."
      ]
    },
    {
      title: "ಆದೇಶ ಸ್ವೀಕೃತಿ ಮತ್ತು ಸಾಗಣೆ ", content: [
        "ಆದೇಶವನ್ನು ನೀಡಿದ ನಂತರ, ನೀವು ಇಮೇಲ್ ದೃಢೀಕರಣವನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ. ಈ ಇಮೇಲ್ ನಮ್ಮ ಆದೇಶದ ಸ್ವೀಕಾರವನ್ನು ಸೂಚಿಸುವುದಿಲ್ಲ.",
        "ನಮ್ಮ ವಿವೇಚನೆಯಿಂದ ಯಾವುದೇ ಆದೇಶವನ್ನು ನಿರಾಕರಿಸುವ ಅಥವಾ ರದ್ದುಗೊಳಿಸುವ ಹಕ್ಕನ್ನು ನಾವು ಕಾಯ್ದಿರಿಸಿದ್ದೇವೆ.",
        "ಶಿಪ್ಪಿಂಗ್ ಮತ್ತು ಡೆಲಿವರಿ ಟೈಮ್‌ಲೈನ್‌ಗಳು ಅಂದಾಜುಗಳಾಗಿವೆ ಮತ್ತು ಬಾಹ್ಯ ಅಂಶಗಳಿಂದ ಉಂಟಾಗುವ ವಿಳಂಬಗಳಿಗೆ ನಾವು ಜವಾಬ್ದಾರರಾಗಿರುವುದಿಲ್ಲ."
      ]
    },
    {
      title: "ಹಿಂತಿರುಗಿಸುವಿಕೆ, ವಿನಿಮಯ ಮತ್ತು ಮರುಪಾವತಿ ", content: [
        "ನಮ್ಮ ವಾಪಸಾತಿ ಮತ್ತು ಮರುಪಾವತಿ ನೀತಿಯು ನೀವು ಉತ್ಪನ್ನಗಳನ್ನು ಹಿಂದಿರುಗಿಸುವ, ವಿನಿಮಯಕ್ಕಾಗಿ ವಿನಂತಿಸುವ ಅಥವಾ ಮರುಪಾವತಿಯನ್ನು ಪಡೆಯುವ ನಿಯಮಗಳನ್ನು ವಿವರಿಸುತ್ತದೆ.",
        "ಉತ್ಪನ್ನಗಳಿಗೆ ಅವುಗಳ ಮೂಲ ಸ್ಥಿತಿಯಲ್ಲಿರುವ (ತೆರೆಯದ, ಬಳಕೆಯಾಗದ, ಹಾಗೆಯೇ ಪ್ಯಾಕೇಜಿಂಗ್‌ನೊಂದಿಗೆ) ಹಿಂತಿರುಗಿಸುವಿಕೆ ಅಥವಾ ವಿನಿಮಯವನ್ನು ಸ್ವೀಕರಿಸಲಾಗುತ್ತದೆ.",
        "ಮರುಪಾವತಿಯನ್ನು ಮೂಲ ಪಾವತಿ ವಿಧಾನಕ್ಕೆ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಪ್ರತಿಫಲಿಸಲು [X ವ್ಯವಹಾರ ದಿನಗಳು] ತೆಗೆದುಕೊಳ್ಳಬಹುದು."
      ]
    },
    {
      title: "ಬಳಕೆದಾರರ ಜವಾಬ್ದಾರಿಗಳು ", content: [
        "ಅನ್ವಯವಾಗುವ ಎಲ್ಲಾ ಸ್ಥಳೀಯ, ರಾಜ್ಯ ಮತ್ತು ರಾಷ್ಟ್ರೀಯ ಕಾನೂನುಗಳಿಗೆ ಅನುಸಾರವಾಗಿ ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ಬಳಸಲು ನೀವು ಸಮ್ಮತಿಸುತ್ತೀರಿ.",
        "ಯಾವುದೇ ಕಾನೂನುಬಾಹಿರ ಅಥವಾ ಮೋಸದ ಚಟುವಟಿಕೆಗಳಿಗೆ ನೀವು ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ಬಳಸುವುದಿಲ್ಲ.",
        "ನಿಮ್ಮ ಖಾತೆಯ ಸುರಕ್ಷತೆಯನ್ನು ನಿರ್ವಹಿಸುವ ಜವಾಬ್ದಾರಿ ನಿಮ್ಮ ಮೇಲಿದೆ."
      ]
    },
    {
      title: "ಮೌಲಿಕ ಆಸ್ತಿಯ ಹಕ್ಕುಗಳು ", content: [
        "ಪಠ್ಯ, ಚಿತ್ರಗಳು, ಗ್ರಾಫಿಕ್ಸ್ ಮತ್ತು ಲೋಗೊಗಳನ್ನು ಒಳಗೊಂಡಂತೆ ವೆಬ್‌ಸೈಟ್‌ನಲ್ಲಿನ ಎಲ್ಲಾ ವಿಷಯಗಳು ಟೆರಾಕ್ಲೆನ್ಜ್™ ನ ಮಾಲೀಕತ್ವದಲ್ಲಿದೆ ಅಥವಾ ಪರವಾನಗಿ ಪಡೆದಿದೆ ಮತ್ತು ಬೌದ್ಧಿಕ ಆಸ್ತಿ ಕಾನೂನುಗಳಿಂದ ರಕ್ಷಿಸಲ್ಪಟ್ಟಿದೆ.",
        "ನೀವು ಪೂರ್ವ ಲಿಖಿತ ಅನುಮತಿಯಿಲ್ಲದೆ ವೆಬ್‌ಸೈಟ್‌ನಿಂದ ಯಾವುದೇ ವಿಷಯವನ್ನು ನಕಲಿಸಬಾರದು, ಪುನರುತ್ಪಾದಿಸಬಾರದು ಅಥವಾ ಬಳಸಬಾರದು."
      ]
    },
    {
      title: " ಹೊಣೆಗಾರಿಕೆಯ ಮಿತಿಗೊಳಿಸುವಿಕೆ ", content: [
        "ಟೆರಾಕ್ಲೆನ್ಜ್™ ಯಾವುದೇ ನೇರ, ಪರೋಕ್ಷ, ಪ್ರಾಸಂಗಿಕ, ವಿಶೇಷ, ಅಥವಾ ವೆಬ್‌ಸೈಟ್ ಅನ್ನು ಬಳಸಲು ಅಸಮರ್ಥತೆಯಿಂದ ಉಂಟಾಗುವ ಹಾನಿಗಳಿಗೆ ಜವಾಬ್ದಾರರಾಗಿರುವುದಿಲ್ಲ.",
        "ಯಾವುದೇ ಸಂದರ್ಭದಲ್ಲಿ ನಮ್ಮ ಹೊಣೆಗಾರಿಕೆಯು ಖರೀದಿಸಿದ ಉತ್ಪನ್ನಕ್ಕೆ ನೀವು ಪಾವತಿಸಿದ ಮೊತ್ತವನ್ನು ಮೀರಬಾರದು."
      ]
    },
    {
      title: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳಲ್ಲಿ ತಿದ್ದುಪಡಿ ", content: [
        "ಈ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಮಾರ್ಪಡಿಸುವ ಅಥವಾ ನವೀಕರಿಸುವ ಹಕ್ಕನ್ನು ನಾವು ಕಾಯ್ದಿರಿಸಿದ್ದೇವೆ.",
        "ಯಾವುದೇ ಬದಲಾವಣೆಗಳನ್ನು ಈ ಪುಟದಲ್ಲಿ ಪೋಸ್ಟ್ ಮಾಡಲಾಗುತ್ತದೆ ಮತ್ತು ಪರಿಷ್ಕೃತ ದಿನಾಂಕವನ್ನು ಅದಕ್ಕೆ ಅನುಗುಣವಾಗಿ ನವೀಕರಿಸಲಾಗುತ್ತದೆ."
      ]
    },
    {
      title: "ಆಧಿಪತ್ಯ ಕಾನೂನು ", content: [
        "ಈ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಭಾರತದ ಕಾನೂನುಗಳಿಗೆ ಅನುಸಾರವಾಗಿ ನಿಯಂತ್ರಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಅರ್ಥೈಸಲಾಗುತ್ತದೆ.",
        "ಈ ನಿಯಮಗಳಿಂದ ಉದ್ಭವಿಸುವ ಯಾವುದೇ ವಿವಾದಗಳು ಬೆಂಗಳೂರಿನ ಕರ್ನಾಟಕ, ಭಾರತದಲ್ಲಿರುವ ನ್ಯಾಯಾಲಯಗಳ ವಿಶೇಷ ನ್ಯಾಯವ್ಯಾಪ್ತಿಗೆ ಒಳಪಟ್ಟಿರುತ್ತವೆ."
      ]
    },
    {
      title: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ ", content: [
        "ವಿಚಾರಣೆಗಾಗಿ, ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ:",
        "ಇಮೇಲ್: Support@terraclenz.com",
        "ಫೋನ್: 7022519222"
      ]
    }
  ];
  const sectionshi = [
    {
      "title": "नियमों की स्वीकृति", "content": [
        "हमारी वेबसाइट का उपयोग करके, आप इन नियमों और शर्तों, साथ ही हमारी गोपनीयता नीति और अन्य लागू नीतियों का पालन करने के लिए सहमत होते हैं।",
        "यदि आप इन शर्तों से सहमत नहीं हैं, तो कृपया हमारी वेबसाइट का उपयोग न करें।"
      ]
    },
    {
      "title": "उपयोगकर्ता पंजीकरण", "content": [
        "खरीदारी करने या हमारी वेबसाइट की कुछ सुविधाओं का उपयोग करने के लिए आपको एक खाता बनाना आवश्यक हो सकता है।",
        "आप पंजीकरण के समय सटीक, अद्यतन और संपूर्ण जानकारी प्रदान करने के लिए सहमत होते हैं और इस जानकारी की सटीकता बनाए रखने के लिए उत्तरदायी हैं।",
        "आप अपने खाते की जानकारी, जिसमें उपयोगकर्ता नाम और पासवर्ड शामिल हैं, की गोपनीयता बनाए रखने के लिए उत्तरदायी हैं।",
        "आप अपने खाते के किसी भी अनधिकृत उपयोग की तुरंत सूचना हमें देने के लिए सहमत होते हैं।"
      ]
    },
    {
      "title": "उत्पाद जानकारी और उपलब्धता", "content": [
        "हम अपनी वेबसाइट पर सटीक उत्पाद विवरण, छवियां और कीमतें प्रदान करने का प्रयास करते हैं।",
        "हालांकि, त्रुटियां या विसंगतियां हो सकती हैं। हम किसी भी ऐसी त्रुटियों को सुधारने और गलत जानकारी के आधार पर किसी भी आदेश को रद्द करने का अधिकार सुरक्षित रखते हैं।",
        "उत्पाद की उपलब्धता परिवर्तन के अधीन है, और हम यह गारंटी नहीं दे सकते कि सभी आइटम हमेशा उपलब्ध रहेंगे।"
      ]
    },
    {
      "title": "मूल्य निर्धारण और भुगतान", "content": [
        "सभी कीमतें भारतीय रुपये में सूचीबद्ध हैं और लागू करों सहित हो सकती हैं, जब तक अन्यथा उल्लेख न किया गया हो।",
        "हम बिना किसी पूर्व सूचना के किसी भी समय कीमतें बदलने का अधिकार सुरक्षित रखते हैं।",
        "उत्पादों का भुगतान उपलब्ध भुगतान विधियों (क्रेडिट/डेबिट कार्ड, नेट बैंकिंग, यूपीआई आदि) के माध्यम से किया जाना चाहिए।",
        "आपकी भुगतान जानकारी को सुरक्षित रूप से तृतीय-पक्ष भुगतान गेटवे के माध्यम से संसाधित किया जाता है।"
      ]
    },
    {
      "title": "आदेश स्वीकृति और शिपिंग", "content": [
        "आदेश देने के बाद, आपको एक ईमेल पुष्टि प्राप्त होगी। यह ईमेल हमारे द्वारा आदेश को स्वीकार करने का संकेत नहीं देता।",
        "हम किसी भी आदेश को अस्वीकार या रद्द करने का अधिकार सुरक्षित रखते हैं।",
        "शिपिंग और डिलीवरी की समय-सीमा अनुमानित है, और बाहरी कारकों के कारण होने वाली देरी के लिए हम उत्तरदायी नहीं हैं।"
      ]
    },
    {
      "title": "वापसी, विनिमय और धनवापसी", "content": [
        "हमारी वापसी और धनवापसी नीति उन शर्तों को रेखांकित करती है जिनके तहत आप उत्पादों को लौटा सकते हैं, विनिमय का अनुरोध कर सकते हैं, या धनवापसी प्राप्त कर सकते हैं।",
        "केवल उन्हीं उत्पादों की वापसी या विनिमय स्वीकार की जाएगी जो अपनी मूल स्थिति में हैं (अनखुले, अप्रयुक्त, और सही पैकेजिंग के साथ)।",
        "धनवापसी मूल भुगतान विधि में संसाधित की जाएगी और इसमें [X व्यावसायिक दिन] लग सकते हैं।"
      ]
    },
    {
      "title": "उपयोगकर्ता की ज़िम्मेदारियाँ", "content": [
        "आप हमारी वेबसाइट का उपयोग सभी लागू स्थानीय, राज्य और राष्ट्रीय कानूनों के अनुसार करने के लिए सहमत होते हैं।",
        "आप वेबसाइट का उपयोग किसी भी अवैध या धोखाधड़ी गतिविधियों के लिए नहीं करेंगे।",
        "आप अपने खाते की सुरक्षा बनाए रखने के लिए उत्तरदायी हैं।"
      ]
    },
    {
      "title": "बौद्धिक संपदा", "content": [
        "वेबसाइट पर उपलब्ध सभी सामग्री, जिसमें पाठ, चित्र, ग्राफिक्स और लोगो शामिल हैं, टे़राक्लेंज™ के स्वामित्व में हैं या इसे लाइसेंस प्राप्त है और बौद्धिक संपदा कानूनों द्वारा संरक्षित हैं।",
        "आप वेबसाइट की किसी भी सामग्री को बिना पूर्व लिखित अनुमति के कॉपी, पुनरुत्पादित या उपयोग नहीं कर सकते।"
      ]
    },
    {
      "title": "देयता की सीमा", "content": [
        "टे़राक्लेंज™ वेबसाइट के उपयोग या उपयोग करने में असमर्थता के कारण होने वाली किसी भी प्रत्यक्ष, अप्रत्यक्ष, आकस्मिक, विशेष या परिणामी क्षति के लिए उत्तरदायी नहीं होगा।",
        "किसी भी स्थिति में हमारी देयता आपके द्वारा खरीदे गए उत्पादों के लिए भुगतान की गई राशि से अधिक नहीं होगी।"
      ]
    },
    {
      "title": "नियम और शर्तों में संशोधन", "content": [
        "हम किसी भी समय इन नियमों और शर्तों को संशोधित या अपडेट करने का अधिकार सुरक्षित रखते हैं।",
        "कोई भी परिवर्तन इस पृष्ठ पर पोस्ट किए जाएंगे, और संशोधित तिथि को अपडेट किया जाएगा।"
      ]
    },
    {
      "title": "न्याय क्षेत्र", "content": [
        "ये नियम और शर्तें भारत के कानूनों द्वारा शासित और व्याख्यायित होंगी।",
        "इन शर्तों से उत्पन्न होने वाले किसी भी विवाद को विशेष रूप से बेंगलुरु, कर्नाटक, भारत के न्यायालयों में हल किया जाएगा।"
      ]
    },
    {
      "title": "संपर्क करें", "content": [
        "किसी भी पूछताछ के लिए हमसे संपर्क करें:",
        "ईमेल: Support@terraclenz.com",
        "फोन: 7022519222"
      ]
    }
  ];

  const [fb, setFB] = useState(fben)
  const [sections, setHomeen] = useState(sectionsen)

  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
    switch (storedLanguage) {
      case "kn":
        setHomeen(sectionska);
        setFB(fbka);
        break;
      case "te":
        setHomeen(sectionste);
        setFB(fbte);
        break;
      case "ta":
        setHomeen(sectionsta);
        setFB(fbta);
        break;
      case "hi":
        setHomeen(sectionshi);
        setFB(fbhi);
        break;
      default:
        setHomeen(sectionsen);
        setFB(fben);
    }

  }, []);
  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2 ">
        <div className="container">
          <div className="breadcrumb-title">
            <h2>{fb["1"]}</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">{fb["2"]}</Link></li>
              <li>{fb["1"]}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="faqs-container">
        {sections.map((section, index) => (
          <div className="faq" key={index}>
            <h6 onClick={() => toggleFAQ(index)} className="faq-question">
              {section.title} {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </h6>
            <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
              {openIndex === index && section.content}
            </div>
          </div>
        ))}
      </div>
    </>
  );

};
export default Terms_and_Conditions;